import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { CButton, H2, CCheckbox } from "@appcues/component-library";
import ChromeExtensionIllustration from "assets/images/chrome-extension.png";
import * as persistence from "helpers/persistence";
import { openFlowInBuilder } from "utils/url";

import Modal from "components/Common/UI/Modal/Modal";

export const OpenInBuilderModal = ({
  stepGroupId,
  stepChildId,
  onClose,
  url
}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleClose = () => {
    if (isChecked) {
      persistence.setItem("dontShowOpenInBuilderModal", true);
    }
    onClose();
  };

  const handleCheck = () => {
    setIsChecked(!isChecked);
  };

  const handleOpenFlow = () => {
    openFlowInBuilder(stepGroupId, stepChildId, url);
    handleClose();
  };
  return (
    <Modal onClose={handleClose} type="medium">
      <Modal.Content>
        <IllustrationContainer>
          <Illustration src={ChromeExtensionIllustration} />
        </IllustrationContainer>
        <TextContainer>
          <H2>Open the extension</H2>
          <p>
            When the page loads, remember to <br />
            <strong> click the Appcues Flow Builder extension </strong>
            and your flow will open.
          </p>
        </TextContainer>

        <Footer>
          <CButton type="primary" onClick={handleOpenFlow}>
            Open flow
          </CButton>

          <CCheckbox
            label="Don't show again"
            checked={isChecked}
            onClick={handleCheck}
          />
        </Footer>
      </Modal.Content>
    </Modal>
  );
};

OpenInBuilderModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string,
  stepGroupId: PropTypes.string,
  stepChildId: PropTypes.string
};

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  label {
    margin-top: 18px !important;
  }
`;

const Illustration = styled.img`
  width: 160px;
  height: 160px;
`;

const IllustrationContainer = styled.div`
  text-align: center;
  margin: 40px 0px 40px 0px;
`;

const TextContainer = styled.div`
  text-align: center;
  margin: 0px 48px 40px 48px;

  p {
    margin-top: 16px;
  }
`;

export default OpenInBuilderModal;
